export default {"id":"14552300","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}